// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.TreeInput__container___Nv4JT .TextField {
    flex-grow: 1;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.TreeInput__container___Nv4JT .TextField-Input {
    overflow: hidden;
    min-width: 5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.TreeInput__container___Nv4JT {
    .TreeInput__button___ZfgjY {
        &:disabled {
            border-right: 0;
        }

        /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
        &:enabled + .TreeInput__textField___lfDOa .TextField-InputContainer {
            border-left: 0;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TreeInput/TreeInput.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;IACI,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI;YACI,eAAe;QACnB;;QAEA,uEAAuE;QACvE;YACI,cAAc;QAClB;IACJ;AACJ","sourcesContent":["/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TextField) {\n    flex-grow: 1;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TextField-Input) {\n    overflow: hidden;\n    min-width: 5rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.container {\n    .button {\n        &:disabled {\n            border-right: 0;\n        }\n\n        /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n        &:enabled + .textField :global(.TextField-InputContainer) {\n            border-left: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TreeInput__container___Nv4JT`,
	"button": `TreeInput__button___ZfgjY`,
	"textField": `TreeInput__textField___lfDOa`
};
export default ___CSS_LOADER_EXPORT___;
